<template>
  <section class="experience" id="experience">
    <br />
    <br />
    <br />
    <h1 class="heading"><span> </span> timeline</h1>

    <div class="box-container">
      <div class="box">
        <i class="fas fa-graduation-cap"></i>
        <div class="content">
          <span> 1994 - 1999 </span>
          <h3>college years</h3>
          <p>economics</p>
          <p>
            faculty of economics & administrative sciences <br />Karadeniz
            Technical University
          </p>
        </div>
      </div>

      <div class="box">
        <i class="fas fa-landmark"></i>
        <div class="content">
          <span> 2000 - 2016 </span>
          <h3>government, civil servant</h3>
          <p>
            Presidency of Defence Industries <br />Presidency of the Republic of
            Turkey
          </p>
        </div>
      </div>

      <div class="box">
        <i class="fab fa-python"></i>

        <div class="content">
          <span> 2015 - 2016 </span>
          <h3>first steps to software development</h3>
          <p>
            After trying to learn Java for a while, I continued with Python.
          </p>
        </div>
      </div>

      <div class="box">
        <i class="fas fa-code"></i>
        <div class="content">
          <span> 2016 - 2021 </span>
          <h3>front-end development</h3>
          <p>
            After Java and Python, I continued with Javascript and tried the
            libraries in the JS Ecosystem. I continued my studies with Vue.
          </p>
        </div>
      </div>

      <div class="box">
        <i class="fab fa-google-play"></i>
        <div class="content">
          <span> 2021 </span>
          <h3>mobile application</h3>
          <p>
            I developed my first mobile application and published it on google
            play market.
          </p>
          <a href="#">toucan</a>
        </div>
      </div>
      <div class="box">
        <i class="fas fa-edit"></i>
        <div class="content">
          <span> 2022 - + </span>
          <h3>future plans</h3>
          <p>I hope to make better web and mobile apps</p>
        </div>
      </div>
    </div>
  </section>
</template>
